


















import SvgImage from '@/app/components/SvgImage.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'Error503',
    metaInfo: {
        title: 'Service Unavailable',
    },
    components: { SvgImage },
});
